import Logo from './logo'
import { Button } from 'antd'
import React, { useState, useEffect } from 'react'
import { ArrowButton, CustomButton } from './other'
import { Link, useLocation } from 'react-router-dom'
import { CloseOutlined, MenuOutlined } from '@ant-design/icons'

function Header() {
  const { pathname } = useLocation()
  const isHome = (pathname === "/")
  const [isOpen, setIsOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)

  const handleOpen = () => {setIsOpen(!isOpen); window.scrollTo({top: 0, behavior: "smooth"})}

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const menu = [
    { key: "/products", label: "Products" },
    { key: "/about", label: "About" },
    { key: "/faqs", label: "FAQs" },
    { key: "/privacy-policy", label: "Privacy" },
    { key: "/terms-&-conditions", label: "Terms" },
  ]
  return (
    <>
      <div className={'w-full flex flex-col fixed top-0 left-0 right-0 z-50 transition-all duration-300 '.concat(isHome ? (isScrolled ? "bg-[#161618] shadow-md" : "bg-transparent") : "bg-white shadow-sm")}>
        <div className='w-full max-w-[1200px] mx-auto px-5 md:px-10 xl:px-0 py-2.5 md:py-3'>
          <div className='w-full flex flex-col md:flex-row justify-between items-center relative'>
            <div className='w-full flex justify-between items-center md:flex-1'>
              <Logo imgClass='!w-[110px] md:!w-[130px]' black={!isHome} />
              <CustomButton onClick={handleOpen} className='!rounded-md md:!hidden'>
                <Button className='hover:!text-[#515594]' icon={isOpen ? <CloseOutlined /> : <MenuOutlined />} />
              </CustomButton>
            </div>

            <div className={'w-full mx-auto md:mx-0 bg-white md:bg-transparent p-5 md:p-0 absolute md:static top-12 shadow-lg md:shadow-none rounded-2xl flex-col md:flex-row md:items-center '.concat(isOpen ? "flex" : "hidden md:flex", " md:flex-[2]")}>
              <div className='md:flex-1 flex md:justify-center'>
                <div className='flex flex-col md:flex-row md:items-center gap-6 lg:gap-10'>
                  {menu.map(({key, label}) => {
                    const isPath = (pathname === key)
                    return (
                    <Link key={key} to={key} onClick={handleOpen} className={'text-sm font-medium hover:text-[#515594] transition-colors duration-200 '.concat(isHome ? "md:text-white" : "text-dark"," ", isPath ? "!text-[#515594] font-semibold" : "")}>{label}</Link>
                  )})}
                </div>
              </div>
              <div className='w-auto md:flex-1 flex md:justify-end mt-3 md:mt-0'>
                <Button href='/contact' onClick={handleOpen} shape='round' className='!bg-[#515594] hover:!bg-[#414476] !border-none !px-6 !h-9 md:!h-10 text-xs sm:text-sm font-semibold !text-white flex items-center justify-center transition-colors'>Contact us</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Spacer to prevent content from hiding under the fixed header on non-home pages */}
      {!isHome && <div className="w-full h-[58px] md:h-[64px]"></div>}
    </>
  )
}

export default Header